/**
 * UI8 Search Border
 * Pulsing WebGL border for the hero search input.
 * Depends on window.PaperShadersUtils (paper-shaders-utils.js).
 * Usage: initSearchBorder(el);
 */

function initSearchBorder(el) {
  window.PaperShadersUtils.mountPulsingBorder(el, {
    u_colors: ['#0d91fd', '#1452f0', '#ff2e2e', '#a855f7'],
    u_colorsCount: 4,
    u_roundness: 1.0,
    u_thickness: 0.015,
    u_softness: 1.0,
    u_intensity: 0.1,
    u_bloom: 0.2,
    u_spots: 4,
    u_spotSize: 0.5,
    u_pulse: 0.0,
    u_smoke: 0.0,
    u_smokeSize: 0.0,
  });
}

window.SearchBorder = { initSearchBorder: initSearchBorder };
